module.exports = __webpack_public_path__ + "asset/image-dashboard-screenshot-9b9fbe54a108e613.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/dashboard-screenshot.png
// module id = t2Si
// module chunks = 1